// Functionality: API Call for Asset Performance Data Points (must send Chart & Metric Column in the request)
import axios from "../../loadBalancerAxios";
import { ASSET_PERFORMANCE_HEADER_URL } from "../../paths";

export const getAssetPerformHeadersAPI = async (metricColumn, setData) => {
  await axios
    .get(`${ASSET_PERFORMANCE_HEADER_URL}?column=${metricColumn}`)
    .then((response) => {
      // Data
      const responseData = response?.data;
      setData({
        loaded: true,
        totalVehicles: responseData?.vehicle_count,
        averageMetric: responseData?.average_metric,
      });
    })
    .catch(() => {
      setData({
        loaded: true,
        totalVehicles: "-",
        averageMetric: "-",
      });
    });
};
